.input {
    scrollbar-width: none;
    /* Makes the first line of the textarea line up in the middle of the input field. */
    padding-top: 18px;

    border: 1px solid transparent;
    border-top: 1px solid var(--mantine-color-default-border) !important;
    background-color: var(--exwo-color-app-bg) !important;

    &[data-variant="filled"] {
        padding-top: 1.2rem;
        padding-bottom: 1.2rem;
    }
}

.input::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.input:hover,
.input:focus-within {
    border: 1px solid var(--mantine-color-default-border);
}

.sendButton {
    &[data-disabled="true"] {
        cursor: not-allowed;
    }
}
